import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faFaceSmile } from '@fortawesome/free-solid-svg-icons/faFaceSmile';
import React from 'react';
import styled from 'styled-components';

import { FontSize } from '../theme/FontSize';
import { Empty } from '../utils/local-antd';
import { AtiraIcon } from './AtiraIcon';
import { Flex } from './Flex';
import { Text } from './Text';

const Container = styled(Flex)<{ iconHeight?: React.CSSProperties['height'] }>`
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;

  .ant-empty-image {
    height: ${({ iconHeight }) => iconHeight};
    display: ${({ iconHeight }) => (iconHeight !== '0' ? 'block' : 'none')};
  }
`;

interface AtiraErrorProps {
  icon?: IconProp;
  description: string | React.ReactNode;
  fontSize?: keyof typeof FontSize;
  iconHeight?: React.CSSProperties['height'];
}

export const AtiraEmpty: React.FC<AtiraErrorProps> = ({
  description,
  icon = faFaceSmile,
  fontSize = 'l',
  iconHeight = '7.5rem',
}) => {
  return (
    <Container iconHeight={iconHeight}>
      <Empty
        image={<AtiraIcon icon={icon} color="main" />}
        description={
          <Text color="main" fontSize={fontSize} align="center">
            {description}
          </Text>
        }
      />
    </Container>
  );
};
